/**
 * Created by Karan variya on 22/12/2018.
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';


import {HttpManagerService}  from '../../api/httpmanager.service';

@Injectable()
export class BackupdbService {
    constructor(
        private httpmanagerService : HttpManagerService
    ){ 
    }

    datbaseBackup(): Promise<any> {
        return this.httpmanagerService.HttpGet('backupDB',"").then(data =>{
            return data;
        })
    }

    list(): Promise<any> {
        return this.httpmanagerService.HttpGet('backupDB/list',"").then(data =>{
            return data;
        })
    }
    deleteDB(id): Promise<any>{
        return this.httpmanagerService.HttpDelete('backupDB',id).then(data =>{
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/backupdb/backupdb.service.ts